(function ($) {

  'use strict';

  Drupal.behaviors.whatIsTheDayToday = {
    attach: function (context) {

      if ($(window).width() > 768) { // only for media breakpoint up "md"
        $(once('whatisthedaytoday', '.date-placeholder', context)).each(function() {
          var today = new Date();
          var weekday = new Intl.DateTimeFormat('fr', { weekday: 'long' }).format(today);
          var ucWeekday = weekday.charAt(0).toUpperCase() + weekday.slice(1);
          var day = new Intl.DateTimeFormat('fr', { day: 'numeric' }).format(today);
          var month = new Intl.DateTimeFormat('fr', { month: 'long' }).format(today);
          var ucMonth = month.charAt(0).toUpperCase() + month.slice(1);
          var year = new Intl.DateTimeFormat('fr', { year: 'numeric' }).format(today);

          $(this).html('<div class="h1">'+ucWeekday+' '+day+'</div><div class="h2">'+ucMonth+' '+year+'</div>');
        });
      }

    }
  };


  Drupal.behaviors.coloredHeaderBg = {
    attach: function (context) {

      if ($('aside.layout-sidebar-first', context).length > 0) {
        var sidebarFirstHeight = $('aside.layout-sidebar-first', context).height() + 160;
        $(once('coloredHeaderBg', 'main', context)).each(function() {
          $(this).before('<div class="colored-header-bg" style="height:'+sidebarFirstHeight+'px"></div>')
        });
      }

    }
  };


  Drupal.behaviors.slickParagraphsCounter = {
    attach: function (context) {

      $('.paragraph.paragraph--type--gallery .slick', context).on('init reInit', function(event, slick) {
        slick.$slides.each(function(index) {
          var slideNumber = index + 1;
          $('.slide__content', slick.$slides[index]).append(
            '<div class="slide__count">' + slideNumber + '/' + slick.slideCount + '</div>'
          );
        });
      });

    }
  };


  Drupal.behaviors.searchToggle = {
    attach: function (context) {

      $(once('searchToggle', '.search-toggle', context)).each(function() {
        $(this).on('click', function(e) {
          e.preventDefault();
          $('#block-sp-twerk-exposed-form-search-page-1-collapsible').toggleClass('open');
          $(this).toggleClass('open');
          if ($('#block-sp-twerk-exposed-form-search-page-1-collapsible').hasClass('open')) {
            $('#block-sp-twerk-exposed-form-search-page-1-collapsible input.form-text').focus();
          }
        });
      });

    }
  };

})(jQuery);
